
<div class="flex flex-row justify-between items-center gap-2 font-rubik">
  <a :href="`tel:${organizationPhone || phoneNumber}`">
    <button
      class="phone-button border rounded-full flex items-center justify-center" 
    >
      <img
        class=""
        src="@/images/header/phone.svg"
        alt="Contact us"
      />
    </button>
  </a>
</div>
